import { Injectable, TemplateRef } from '@angular/core';

export interface Toast {
	message: string;
	type?: toastTypeEnum;
	delay?: number;
}

export enum toastTypeEnum {
	primary,
	secondary,
	success,
	danger,
	warning,
	info,
	dark
}

@Injectable({ providedIn: 'root' })
export class ToastService {
	delay: number = 5000;
	toasts: Toast[] = [];

	getToastTypeClass(toast: Toast) {
		switch (toast.type) {
			case toastTypeEnum.primary: {
				return 'bg-primary text-light'
			}
			case toastTypeEnum.secondary: {
				return 'bg-secondary text-light'
			}
			case toastTypeEnum.success: {
				return 'bg-success text-light'
			}
			case toastTypeEnum.danger: {
				return 'bg-danger text-light'
			}
			case toastTypeEnum.warning: {
				return 'bg-warning text-dark'
			}
			case toastTypeEnum.info: {
				return 'bg-info text-light'
			}
			case toastTypeEnum.dark: {
				return 'bg-dark text-light'
			}
			default: {
				return '';
			}
		}
	}

	getToastHeader(toast: Toast) {
		switch (toast.type) {
			case toastTypeEnum.primary: {
				return 'Information'
			}
			case toastTypeEnum.secondary: {
				return 'Information'
			}
			case toastTypeEnum.success: {
				return 'Success'
			}
			case toastTypeEnum.danger: {
				return 'Failure'
			}
			case toastTypeEnum.warning: {
				return 'Warning'
			}
			case toastTypeEnum.info: {
				return 'Information'
			}
			case toastTypeEnum.dark: {
				return 'Error'
			}
			default: {
				return '';
			}
		}
	}

	show(toast: Toast) {
		this.toasts.push(toast);
	}

	remove(toast: Toast) {
		this.toasts = this.toasts.filter((t) => t !== toast);
	}

	clear() {
		this.toasts.splice(0, this.toasts.length);
	}
}